import { render, staticRenderFns } from "./PayrollPreviewSummary.vue?vue&type=template&id=60b0f67f"
import script from "./PayrollPreviewSummary.vue?vue&type=script&lang=js"
export * from "./PayrollPreviewSummary.vue?vue&type=script&lang=js"
import style0 from "./PayrollPreviewSummary.vue?vue&type=style&index=0&id=60b0f67f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports